const bakeHistoryInFullPath = (fullPath?: string[], history: string[] = []) => {
	if (fullPath === undefined) return undefined;
	return fullPath.map((pathItem, idx) => (pathItem === "_" ? history[idx] || "_" : pathItem));
};

export default bakeHistoryInFullPath;
